/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.factory('copyToClipboard', ngNotify => ({
    copy(id) {
        const element = angular.element(document.querySelector('#' + id));
        element[0].select();
        const success = document.execCommand('copy');
        if (!success) {
            return ngNotify.set('La copie dans le clipboard a échouée (?!)', 'error');
        } else {
            return ngNotify.set('Copié dans le clipboard !', 'success');
        }
    }
}));
